import { TextField } from '@ovComponents/2-component/textField/textField';
import { t } from 'i18next';

interface NumberFieldProps extends React.ComponentProps<typeof TextField> {
  number: string;
  setNumber: (number: string) => void;
  label?: string;
  onBlur?: any;
  error?: any;
  errorText?: any;
  sx?: any;
  disabled?: boolean;
  locked?: boolean;
  infoTooltip?: string;
  decimalPlaces?: number;
  unlimitedDecimals?: boolean;
  testId?: string;
  trailingIcon?: 'percent' | 'calendar' | undefined;
  showArrows?: boolean;
  textSize?: string | number;
  textAlign?: 'left' | 'center' | 'right';
  InputProps?: any;
  required?: boolean;
  max?: number;
  min?: number;
  unsigned?: boolean;
  size?: 'small' | 'medium';
  lockMessage?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
}
export const NumberField = ({
  number,
  setNumber,
  label,
  onBlur,
  error,
  sx,
  infoTooltip,
  disabled,
  locked,
  testId,
  decimalPlaces = 2,
  unlimitedDecimals = false,
  trailingIcon = undefined,
  showArrows = true,
  textSize = '16px',
  textAlign = 'left',
  InputProps,
  required = false,
  max,
  min,
  errorText,
  unsigned = false,
  size = 'medium',
  lockMessage,
  onKeyDown,
  fullWidth = true,
  ...rest
}: NumberFieldProps) => (
  <TextField
    testId={testId ?? 'number-field'}
    onKeyDown={onKeyDown}
    onChange={(e: any) => {
      const { value } = e.target;

      if (typeof max === 'number' && value !== '') {
        if (parseFloat(value) > max) {
          return;
        }
      }
      if (typeof min === 'number' && value !== '') {
        if (parseFloat(value) < min) {
          return;
        }
      }

      if (unsigned && value.includes('-')) {
        return;
      }
      if (!unlimitedDecimals && value.includes('.')) {
        const [whole, decimal] = value.split('.');
        if (decimal.length > decimalPlaces) {
          setNumber(`${whole}.${decimal.slice(0, decimalPlaces)}`);
          return;
        }
      }
      setNumber(value);
    }}
    label={label ?? t('components:number')}
    fullWidth={fullWidth}
    lockMessage={lockMessage ?? t('pageConfiguration:notEditableMessage')}
    disabled={disabled}
    locked={locked}
    value={number}
    decimalPlaces={decimalPlaces}
    unlimitedDecimals={unlimitedDecimals}
    placeholder={decimalPlaces ? `0.${'0'.repeat(decimalPlaces)}` : '0'}
    type='number'
    onBlur={onBlur}
    error={error}
    errorText={errorText}
    sx={sx}
    infoTooltip={infoTooltip}
    trailingIcon={trailingIcon}
    showArrows={showArrows}
    textSize={textSize}
    textAlign={textAlign}
    size={size}
    InputProps={InputProps}
    required={required}
    {...rest}
  />
);
